import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';

export type ProfileMenuActionId =
  | 'home'
  | 'convert'
  | 'scheduledOrders'
  | 'portfolio'
  | 'accounts'
  | 'support'
  | 'terms'
  | 'unsubscribe'
  | 'logout';

@Component({
  selector: 'app-profile-menu-panel',
  standalone: true,
  templateUrl: './profile-menu-panel.component.html',
  styleUrls: ['./profile-menu-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileMenuPanelComponent {
  readonly primarySection = [
    { id: 'home' as const, label: 'Inicio' },
    { id: 'convert' as const, label: 'Conversión' },
    { id: 'scheduledOrders' as const, label: 'Programar órdenes' },
    { id: 'portfolio' as const, label: 'Mi portafolio' },
  ];

  readonly profileSubmenuExpanded = signal(true);

  readonly actionClick = output<ProfileMenuActionId>();

  toggleProfileSubmenu(event: MouseEvent): void {
    event.stopPropagation();
    this.profileSubmenuExpanded.update((open) => !open);
  }

  emitAction(id: ProfileMenuActionId, event?: Event): void {
    event?.stopPropagation();
    this.actionClick.emit(id);
  }
}
